/******************************************************************************
 *                                                                            *
 *  Copyright (c) 2018, 2025 by AsterionDB Inc.                               *
 *                                                                            *
 *  All rights reserved.  No part of this work may be reproduced or otherwise *
 *  incorporated into other works without the express written consent of      *
 *  AsterionDB Inc.                                                           *
 *                                                                            *
 *****************************************************************************/

import React from 'react'
import { TabContent, TabPane, Nav, NavItem, NavLink, Button, 
  Row, Col, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap'
import { JsonView } from 'react-json-view-lite';
import 'react-json-view-lite/dist/index.css';
import classnames from 'classnames';

import ObjectProperties from './ObjectProperties.js'
import GenerateSecureWeblink from '../../widgets/GenerateSecureWeblink.js'
import FilenameGenerator from '../../widgets/FilenameGenerator.js'
import ObjectKeywords from './ObjectKeywords.js'
import ObjectVersions from './ObjectVersions.js'
import ObjectStreamingHistory from './ObjectStreamingHistory.js'
import ObjectGatewayHistory from './ObjectGatewayHistory.js'
import ObjectSharing from './ObjectSharing.js'
import SimilaritySearch from '../../widgets/SimilaritySearch.js'
import { AppContext } from '../../AppContext'

import ReactPlayer from 'react-player/lazy'

class ObjectModal extends React.Component
{

  closing = false;
  refreshVaultViewTabOnClose = false;
  weblinkGenerated = false;
  tabTypes = null;
  elementRef = null;

  componentDidMount()
  {
    if (this.props.rowInfo.htmlElement !== null && 'deleted' !== this.props.viewType && 
        !this.weblinkGenerated && ('viewer' === this.tabTypes[this.props.activeObjectModalTab] ||
        'similaritySearch' === this.tabTypes[this.props.activeObjectModalTab])) 
      this.generateWeblink();

    if (1 === this.state.tabIndex && ('ReactJson' === this.props.rowInfo.htmlElement ||'XmlViewer' === this.props.rowInfo.htmlElement)) 
      this.getObjectData();
}
  constructor(props)
  {
    super();

    let activeTab = (1 === props.activeObjectModalTab && null === props.rowInfo.htmlElement ? 
      0 : props.activeObjectModalTab);

    this.state =
    {
      tabIndex: activeTab,
      versionData: [],
      objectUrl: null,
      objectData: undefined
    }

    this.toggleModal = this.toggleModal.bind(this);
    this.toggleTab = this.toggleTab.bind(this);
    this.objectTransformed = this.objectTransformed.bind(this);
    this.refreshVaultViewTab = this.refreshVaultViewTab.bind(this);

    this.elementRef = React.createRef();

    switch (props.viewType)
    {
      case 'cataloged':
      case 'uncataloged':
        this.tabTypes = ['properties', 'viewer', 'similaritySearch', 'keywords', 'gateway', 'weblink', 'sharing', 'versions', 'streamingHistory', 'gatewayHistory'];
        break;

      case 'shared':
        this.tabTypes = ['properties', 'viewer', 'gateway', 'weblink', 'streamingHistory', 'gatewayHistory'];
        break;

      case 'deleted':
        this.tabTypes = ['properties', 'keywords'];
        break;

      default:
        break;
    }
  }

  async generateWeblink()
  {
    let bodyData = {objectId: this.props.rowInfo.objectId, contentDisposition: 'STREAM'};
    let result = await this.context.dbTwig.callRestAPI('dgBunker', 'generateObjectWeblink', bodyData);
    if ('success' !== result.status) return this.context.dbTwig.apiErrorHandler(result, 'Error generating an object weblink');
    this.weblinkGenerated = true;
    this.setState({objectUrl: result.jsonData.objectWeblink});
  }

  async getObjectData()
  {
    let bodyData = {objectId: this.props.rowInfo.objectId};
    let result = await this.context.dbTwig.callRestAPI('dgBunker', 'getObjectData', bodyData);
    if ('success' !== result.status) return this.context.dbTwig.apiErrorHandler(result, 'Error getting object data');
    this.setState({objectData: result.jsonData})
  }

  objectTransformed()
  {
    this.props.transformObject(this.props.rowInfo.rowIndex);
  }

  refreshVaultViewTab()
  {
    this.refreshVaultViewTabOnClose = true;
  }

  render()
  {
    if (undefined === this.props.rowInfo || !this.props.objectModalIsOpen) return null;

    let objectHeight = window.outerHeight * .6;

    if (this.props.objectModalIsOpen) this.closing = false;

    let objectTypeIds = [];
    objectTypeIds[0] = this.props.rowInfo.objectTypeId;
    let objectIds = [];
    objectIds[0] = this.props.rowInfo.objectId;
    let navElement = null;
    let tabContentElement = null;
    let immutableRowFound = this.props.rowInfo.immutableKeywords;
    let appContext = this.context;
    let selectedObjects = [];
    selectedObjects.push(this.props.rowInfo);

    if ('cataloged' === this.props.viewType || 'uncataloged' === this.props.viewType)
    {
      navElement = 
      (
        <Nav tabs>
          <NavItem>
            <NavLink
              className={classnames({ active: this.state.tabIndex === 0 })} onClick={() => { this.toggleTab(0); }} >
              Properties
            </NavLink>
          </NavItem>
        { null !== this.props.rowInfo.htmlElement &&
          <NavItem>
            <NavLink className={classnames({ active: this.state.tabIndex === 1 })} onClick={() => { this.toggleTab(1); }} >
              Viewer
            </NavLink>
          </NavItem>
        }
        { window.extensionEnabled(this.context.websiteProfile.installedExtensions, this.context.extensions.AI) &&
           'Yes' === this.props.rowInfo.embeddingsGenerated && 'image' === this.props.rowInfo.vectorModality &&
          <NavItem>
            <NavLink className={classnames({ active: this.state.tabIndex === 2 })} onClick={() => { this.toggleTab(2); }} >
              Similarity Search
            </NavLink>
          </NavItem>
        }
          <NavItem>
            <NavLink
              className={classnames({ active: this.state.tabIndex === 3 })} onClick={() => { this.toggleTab(3); }} >
              Keywords
            </NavLink>
          </NavItem>
        { '' !== this.context.appLocalStorage.getGatewayName() &&
          <NavItem>
            <NavLink
              className={classnames({ active: this.state.tabIndex === 4 })} onClick={() => { this.toggleTab(4); }} >
              Gateway
            </NavLink>
          </NavItem>
        }
          <NavItem>
            <NavLink
              className={classnames({ active: this.state.tabIndex === 5 })} onClick={() => { this.toggleTab(5); }} >
              Weblink
            </NavLink>
          </NavItem>
        { 'Y' === appContext.websiteProfile.sharingEnabled && this.context.userSession.shareObjectsEnabled(this.context.userUiProfile.grantedPermissions) &&
          <NavItem>
            <NavLink
              className={classnames({ active: this.state.tabIndex === 6 })} onClick={() => { this.toggleTab(6); }} >
              Sharing
            </NavLink>
          </NavItem>
        }
          <NavItem>
            <NavLink
              className={classnames({ active: this.state.tabIndex === 7 })} onClick={() => { this.toggleTab(7); }} >
              Versions
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames({ active: this.state.tabIndex === 8 })} onClick={() => { this.toggleTab(8); }} >
              Streaming History
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames({ active: this.state.tabIndex === 9 })} onClick={() => { this.toggleTab(9); }} >
              Gateway History
            </NavLink>
          </NavItem>
        </Nav>
      );
  
      tabContentElement =
      (
        <TabContent activeTab={this.state.tabIndex}>
          <TabPane tabId={0}>
            <Row>
              <Col sm="12">
              { 0 === this.state.tabIndex &&
                <ObjectProperties selectedObject={this.props.rowInfo} viewType={this.props.viewType} 
                  refreshVaultViewTab={this.refreshVaultViewTab} toggleModal={this.toggleModal}
                  deleteRestoreOrPurge={this.props.deleteRestoreOrPurge} toggleImmutableObject={this.props.toggleImmutableObject}
                  setStorageTier={this.props.setStorageTier} toggleCaptureDetail={this.props.toggleCaptureDetail}
                />
              }
              </Col>
            </Row>
          </TabPane>
        { null !== this.props.rowInfo.htmlElement &&
          <TabPane tabId={1}>
            <Row>
            {( 1 === this.state.tabIndex &&
              <Col sm="12">
                { 'ReactJson' === this.props.rowInfo.htmlElement && undefined !== this.state.objectData &&
                  <div><JsonView data={JSON.parse(this.state.objectData.data)}/></div>
                }
                { 'img' === this.props.rowInfo.htmlElement && 
                  <div>
                    <img style={{maxWidth: '100%', paddingTop: '10px', paddingBottom: '10px', marginLeft: 'auto', marginRight: 'auto', display: 'block'}} 
                      src={this.state.objectUrl}  alt="Object view" 
                    />
                  </div>
                }
                {'object' === this.props.rowInfo.htmlElement && 
                  <div>
                    <object style={{height: objectHeight, width: '100%'}} type={this.props.rowInfo.mimeType} data={this.state.objectUrl}>AsterionDB Generic Viewer</object>
                  </div>
                }
                {'Player' === this.props.rowInfo.htmlElement &&
                  <div className='player-wrapper'>          
                    <ReactPlayer url={this.state.objectUrl} controls={true} width='100%' height='100%' className='react-player'/>
                  </div>
                }
              </Col>  
            )}
            </Row>
          </TabPane>
        }
        { window.extensionEnabled(this.context.websiteProfile.installedExtensions, this.context.extensions.AI) &&
          'Yes' === this.props.rowInfo.embeddingsGenerated && 'image' === this.props.rowInfo.vectorModality &&
          <TabPane tabId={2}>
            <Row>
              <Col style={{paddingTop: "10px"}} sm="12">
                <SimilaritySearch source={this.state.objectUrl} selectedObjects={this.props.selectedObjects} viewType={this.props.viewType}
                  objectTypePickerData={this.props.objectTypePickerData} filterData={this.props.filterData} matchAnyOrAll={this.props.matchAnyOrAll}
                  objectId={this.props.rowInfo.objectId}
                />
              </Col>
            </Row>
          </TabPane>
        }
          <TabPane tabId={3}>
            <Row>
              <Col sm="12">
              {( 3 === this.state.tabIndex &&
                <ObjectKeywords immutableRowFound={immutableRowFound}  tabIndex={this.props.tabIndex} selectedObjects={selectedObjects} 
                  refreshVaultViewTab={this.refreshVaultViewTab} refreshQueryValues={this.props.refreshQueryValues} viewType={this.props.viewType} 
                />
              )}
              </Col>
            </Row>
          </TabPane>
        { ( '' !== this.context.appLocalStorage.getGatewayName() &&          
          <TabPane tabId={4}>
            <Row>
              <Col sm="12">
              {( 4 === this.state.tabIndex &&
                <FilenameGenerator selectedObject={this.props.rowInfo} viewType={this.props.viewType} />
              )}
              </Col>
            </Row>
          </TabPane>
          )
        }
          <TabPane tabId={5}>
            <Row>
              <Col sm="12">
              {( 5 === this.state.tabIndex &&
                <GenerateSecureWeblink selectedObject={this.props.rowInfo} modalSize='modal-lg' />
              )}
              </Col>
            </Row>
          </TabPane>
        { ( 'Y' === appContext.websiteProfile.sharingEnabled && this.context.userSession.shareObjectsEnabled(this.context.userUiProfile.grantedPermissions) &&
          <TabPane tabId={6}>
            <Row>
              <Col sm="12">
              {( 6 === this.state.tabIndex &&
                <ObjectSharing selectedObjects={selectedObjects} refreshVaultViewTab={this.refreshVaultViewTab} 
                  ref={this.elementRef}
                />
              )}
              </Col>
            </Row>
          </TabPane>
          )
        }
          <TabPane tabId={7}>
            <Row>
              <Col sm="12">
              {( 7 === this.state.tabIndex &&
                <ObjectVersions selectedObject={this.props.rowInfo}  objectTransformed={this.objectTransformed}
                  versionData={this.state.versionData} refreshVaultViewTab={this.refreshVaultViewTab} 
                />
              )}
              </Col>
            </Row>
          </TabPane>
          <TabPane tabId={8}>
            <Row>
              <Col sm="12">
              {( 8 === this.state.tabIndex &&
                <ObjectStreamingHistory objectId={this.props.rowInfo.objectId} />
              )}
              </Col>
            </Row>
          </TabPane>
          <TabPane tabId={9}>
            <Row>
              <Col sm="12">
              {( 9 === this.state.tabIndex &&
                <ObjectGatewayHistory objectId={this.props.rowInfo.objectId} />
              )}
              </Col>
            </Row>
          </TabPane>
        </TabContent>        
      );        
    }

    if ('shared' === this.props.viewType)
    {
      navElement = 
      (
        <Nav tabs>
          <NavItem>
            <NavLink className={classnames({ active: this.state.tabIndex === 0 })} onClick={() => { this.toggleTab(0); }} >
              Properties
            </NavLink>
          </NavItem>
        { null !== this.props.rowInfo.htmlElement &&
          <NavItem>
            <NavLink className={classnames({ active: this.state.tabIndex === 1 })} onClick={() => { this.toggleTab(1); }} >
              Viewer
            </NavLink>
          </NavItem>
        }          
          <NavItem>
            <NavLink className={classnames({ active: this.state.tabIndex === 2 })} onClick={() => { this.toggleTab(2); }} >
              Keywords
            </NavLink>
          </NavItem>
        { '' !== this.context.appLocalStorage.getGatewayName() &&
          <NavItem>
            <NavLink className={classnames({ active: this.state.tabIndex === 3 })} onClick={() => { this.toggleTab(3); }} >
              Gateway
            </NavLink>
          </NavItem>
        }
          <NavItem>
            <NavLink className={classnames({ active: this.state.tabIndex === 4 })} onClick={() => { this.toggleTab(4); }} >
              Weblink
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink className={classnames({ active: this.state.tabIndex === 5 })} onClick={() => { this.toggleTab(5); }} >
              Streaming History
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink className={classnames({ active: this.state.tabIndex === 6 })} onClick={() => { this.toggleTab(6); }} >
              Gateway History
            </NavLink>
          </NavItem>
        </Nav>
      );
  
      tabContentElement =
      (
        <TabContent activeTab={this.state.tabIndex}>
          <TabPane tabId={0}>
            <Row>
              <Col sm="12">
              {( 0 === this.state.tabIndex &&
                <ObjectProperties selectedObject={this.props.rowInfo} viewType={this.props.viewType} 
                  refreshVaultViewTab={this.refreshVaultViewTab} toggleModal={this.toggleModal}
                  deleteRestoreOrPurge={this.props.deleteRestoreOrPurge}
                />
              )}
              </Col>
            </Row>
          </TabPane>
        { null !== this.props.rowInfo.htmlElement &&
          <TabPane tabId={1}>
            <Row>
            { 1 === this.state.tabIndex &&
              <Col sm="12">
                { 'ReactJson' === this.props.rowInfo.htmlElement && undefined !== this.state.objectData &&
                  <div><JsonView data={JSON.parse(this.state.objectData.data)}/></div>
                }
                { 'img' === this.props.rowInfo.htmlElement && 
                  <div>
                    <img style={{maxWidth: '100%', paddingTop: '10px', paddingBottom: '10px', marginLeft: 'auto', marginRight: 'auto', display: 'block'}} 
                      src={this.state.objectUrl} alt="Object view" 
                    />
                  </div>
                }
                {'object' === this.props.rowInfo.htmlElement && 
                  <div>
                    <object style={{height: objectHeight, width: '100%'}} type={this.props.rowInfo.mimeType} data={this.state.objectUrl}>AsterionDB Generic Viewer</object>
                  </div>
                }
                {'Player' === this.props.rowInfo.htmlElement &&
                  <div className='player-wrapper'>          
                    <ReactPlayer url={this.state.objectUrl} controls={true} width='100%' height='100%' className='react-player'/>
                  </div>
                }
              </Col>  
            }
            </Row>
          </TabPane>
        }
          <TabPane tabId={2}>
            <Row>
              <Col sm="12">
              {( 2 === this.state.tabIndex &&
                <ObjectKeywords immutableRowFound={immutableRowFound}  tabIndex={this.props.tabIndex} objectTypeIds={objectTypeIds} 
                  objectIds={objectIds} refreshVaultViewTab={this.refreshVaultViewTab} refreshQueryValues={this.props.refreshQueryValues}
                  viewType={this.props.viewType} selectedObjects={selectedObjects} 
                />
              )}
              </Col>
            </Row>
          </TabPane>
          <TabPane tabId={3}>
            <Row>
              <Col sm="12">
              {( 3 === this.state.tabIndex &&
                <FilenameGenerator selectedObject={this.props.rowInfo} viewType={this.props.viewType} />
              )}
              </Col>
            </Row>
          </TabPane>
          <TabPane tabId={4}>
            <Row>
              <Col sm="12">
              {( 4 === this.state.tabIndex &&
                <GenerateSecureWeblink selectedObject={this.props.rowInfo} modalSize='modal-lg' />
              )}
              </Col>
            </Row>
          </TabPane>
          <TabPane tabId={5}>
            <Row>
              <Col sm="12">
              {( 5 === this.state.tabIndex &&
                <ObjectStreamingHistory objectId={this.props.rowInfo.objectId} />
              )}
              </Col>
            </Row>
          </TabPane>
          <TabPane tabId={6}>
            <Row>
              <Col sm="12">
              {( 6 === this.state.tabIndex &&
                <ObjectGatewayHistory objectId={this.props.rowInfo.objectId} />
              )}
              </Col>
            </Row>
          </TabPane>
        </TabContent>        
      );        
    }

    if ('deleted' === this.props.viewType)
    {
      navElement = 
      (
        <Nav tabs>
          <NavItem>
            <NavLink
              className={classnames({ active: this.state.tabIndex === '0' })} onClick={() => { this.toggleTab(0); }} >
              Properties
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames({ active: this.state.tabIndex === '1' })} onClick={() => { this.toggleTab(1); }} >
              Keywords
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames({ active: this.state.tabIndex === 2 })} onClick={() => { this.toggleTab(2); }} >
              Streaming History
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames({ active: this.state.tabIndex === 3 })} onClick={() => { this.toggleTab(3); }} >
              Gateway History
            </NavLink>
          </NavItem>
        </Nav>
      );
  
      tabContentElement =
      (
        <TabContent activeTab={this.state.tabIndex}>
          <TabPane tabId={0}>
            <Row>
              <Col sm="12">
              {( 0 === this.state.tabIndex &&
                <ObjectProperties selectedObject={this.props.rowInfo} viewType={this.props.viewType} 
                  refreshVaultViewTab={this.props.refreshVaultViewTab} toggleModal={this.toggleModal}
                  deleteRestoreOrPurge={this.props.deleteRestoreOrPurge} 
                />
              )}
              </Col>
            </Row>
          </TabPane>
          <TabPane tabId={1}>
            <Row>
              <Col sm="12">
              {( 1 === this.state.tabIndex &&
                <ObjectKeywords immutableRowFound={immutableRowFound} tabIndex={this.props.tabIndex} 
                  objectTypeIds={objectTypeIds} objectIds={objectIds} refreshVaultViewTab={this.refreshVaultViewTab} 
                  refreshQueryValues={this.props.refreshQueryValues} viewType={this.props.viewType} 
                  selectedObjects={selectedObjects} 
                />
              )}
              </Col>
            </Row>
          </TabPane>
          <TabPane tabId={2}>
            <Row>
              <Col sm="12">
              {( 2 === this.state.tabIndex &&
                <ObjectStreamingHistory objectId={this.props.rowInfo.objectId} />
              )}
              </Col>
            </Row>
          </TabPane>
          <TabPane tabId={3}>
            <Row>
              <Col sm="12">
              {( 3 === this.state.tabIndex &&
                <ObjectGatewayHistory objectId={this.props.rowInfo.objectId} />
              )}
              </Col>
            </Row>
          </TabPane>
        </TabContent>        
      );
    }   

    return(
      <Modal className="modal-lg" isOpen={this.props.objectModalIsOpen} toggle={this.toggleModal} autoFocus={false} >
        <ModalHeader toggle={(e) => {this.toggleModal(e)}}>Object Details: {this.props.rowInfo.objectName}</ModalHeader>
        <ModalBody>
          {navElement}
          {tabContentElement}
        </ModalBody>
        <ModalFooter>
          <Button className="float-right" color="primary" onClick={this.toggleModal}>Close</Button>
        </ModalFooter>
      </Modal>
    );
  }

  toggleModal(event)
  {
    if (this.closing) return;

    if (null !== this.elementRef.current && !this.elementRef.current.canModalClose()) return;

    this.closing = true;
    this.weblinkGenerated = false;
    this.props.onClose();
    if (this.refreshVaultViewTabOnClose) this.props.refreshVaultViewTab();
    this.refreshVaultViewTabOnClose = false;
    this.setState({objectUrl: null, versionData: []});
  }

  toggleTab(tabIndex)
  {
    if ('viewer' === this.tabTypes[tabIndex] && ('ReactJson' === this.props.rowInfo.htmlElement || 'XmlViewer' === this.props.rowInfo.htmlElement)) 
      this.getObjectData();

    if (('viewer' === this.tabTypes[tabIndex] || 'similaritySearch' === this.tabTypes[tabIndex]) && 'deleted' !== this.props.viewType && 
      null !== this.props.rowInfo.htmlElement && !this.weblinkGenerated) this.generateWeblink();

    if (this.state.tabIndex !== tabIndex)
    {
      this.setState({ tabIndex: tabIndex });
      this.props.setActiveObjectModalTab(tabIndex);
    }
  }
}

ObjectModal.contextType = AppContext;

export default ObjectModal
